import { useEffect, useMemo, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Header.css";

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const segment = location.pathname.split("/")[1];
  const lang = segment === "en" ? "en" : "fa";
  const otherLang = lang === "en" ? "fa" : "en";

  const otherLangPath = useMemo(() => {
    const rest = location.pathname.replace(/^\/(fa|en)(?=\/|$)/, "");
    return `/${otherLang}${rest}${location.search}${location.hash}`;
  }, [location.pathname, location.search, location.hash, otherLang]);

  const menu = [
    { to: "", label: t("nav.home") },
    { to: "service", label: t("nav.service") },
    { to: "gallery", label: t("nav.gallery") },
    { to: "personel", label: t("nav.personel") },
    { to: "aboutus", label: t("nav.about") },
    { to: "contactus", label: t("nav.contact") },
  ];

  useEffect(() => setIsMobileMenuOpen(false), [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMobileMenuOpen]);

  const renderMenu = (mobile = false) => menu.map((item) => (
    <NavLink
      key={item.to || "home"}
      to={`/${lang}${item.to ? `/${item.to}` : ""}`}
      end={!item.to}
      onClick={() => mobile && setIsMobileMenuOpen(false)}
      className={({ isActive }) => isActive ? "active" : undefined}
    >
      {item.label}
    </NavLink>
  ));

  return (
    <header className="noPadding">
      <div className="container">
        <div className="col-xs-12 col-md-12 noPadding parent">
          <div className="col-md-2 col-xs-4 noPadding child fade-in from-right delay-1 visible">
            <div className="logo">
              <Link to={`/${lang}`}><img alt="logo" className="w-60" src="/assets/logo.png" /></Link>
            </div>
          </div>

          <div className="header-menu-container">
            <nav className="desktop-menu">{renderMenu()}</nav>
            <Link className="lang-switch d-none ml-5 mr-5" to={otherLangPath}>{otherLang.toUpperCase()}</Link>
            <button
              type="button"
              className="mobile-menu-button"
              onClick={() => setIsMobileMenuOpen((open) => !open)}
              aria-expanded={isMobileMenuOpen}
              aria-label="Toggle mobile menu"
            >
              <div className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}><span /><span /><span /></div>
            </button>
          </div>

          <div className="col-md-2 col-xs-12 noPadding child accessnumber fade-in from-bottom delay-3 visible">
            <a className="btn_blue p-2" href="tel:02140443116"><img alt="phone" className="w-20" src="/assets/724.png" />021-40443116</a>
          </div>
        </div>
      </div>

      <nav className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>{renderMenu(true)}<Link className="lang-switch" to={otherLangPath}>{otherLang.toUpperCase()}</Link></nav>
    </header>
  );
}
